import toast from "react-hot-toast";

import useSSE from "../../hooks/useSSE";

// DO NOT use this hook directly in components or other hooks
// this is an internal hook that should be only used by MeetingDetailsProvider, to provide centralized state management and logic control
export default function useCurrentUserSSE({ currentUserEventSourceRef, meeting, store, startStreaming, stopStreaming }) {
  useSSE(currentUserEventSourceRef, meeting && `/lw/${meeting.mid}/my-sse`, {
    "join-error": () => {
      console.log("USSE: join-error");
      store.setJoinError(true);
    },
    "join-janus": (janusConfigs) => {
      console.log("USSE: join-janus", janusConfigs);
      startStreaming(janusConfigs);
      store.setJanusConfig(janusConfigs);
    },
    "join-progress": ({ debug }) => {
      console.log("USSE: join-progress; Debug: ", debug);
      debug && toast.success(debug.msg);
      store.increaseJoinProgress();
    },
    "join-complete": ({ debug }) => {
      console.log("USSE: join-complete; Debug: ", debug);
      debug && toast.success(debug.msg);
      store.persistStore();
      store.setJoinComplete();
    },
    "leave-janus": () => {
      console.log("USSE: leave-janus");
      stopStreaming();
      store.setIsLeaving(true);
    },
    "leave-progress": ({ debug }) => {
      console.log("USSE: leave-janus");
      stopStreaming();
      store.setIsLeaving(true);
      // TODO remove upper lines from here as soon as the real leave-janus event will appear on the backend
      console.log("USSE: leave-progress");
      debug && toast.success(debug.msg);
      store.increaseLeaveProgress();
    },
    "leave-complete": () => {
      console.log("USSE: leave-complete");
      store.setLeaveComplete();
    },
    audio: ({ mute }) => {
      console.log("USSE: audio", { mute });
      store.setAudioMute(mute);
    },
    video: ({ mute }) => {
      console.log("USSE: video", { mute });
      store.setVideoMute(mute);
    },
  });
}
